import queryString, { type UrlObject } from "query-string";

import { Environment, environment, legacyURLs } from "./config";
import { SearchParam } from "./types";

export const stringify = (params: Record<string, unknown>) => {
  return queryString.stringify(params, {
    skipEmptyString: true,
    skipNull: true,
  });
};

export const stringifyUrl = (object: UrlObject) => {
  return queryString.stringifyUrl(object, {
    skipEmptyString: true,
    skipNull: true,
  });
};

export const urlWithZendeskAuth = (returnTo: string) => {
  return queryString.stringifyUrl({
    url: "/auth/zendesk/login",
    query: { [SearchParam.ReturnTo]: returnTo },
  });
};

export const searchParamAsOptionalString = (
  param: string | string[] | null
): string | undefined => {
  if (param === null) {
    return;
  }

  if (Array.isArray(param)) {
    return param.join(",");
  }

  return param;
};

export const getShaprURLProtocol = (): "shapr3dbeta" | "shapr3d" => {
  const search = new URLSearchParams(window.location.search);
  if (search.has(SearchParam.BetaApp)) return "shapr3dbeta";
  if (search.has(SearchParam.ProdApp)) return "shapr3d";

  return environment === Environment.PROD ? "shapr3d" : "shapr3dbeta";
};

export const sanitizeRedirectUrl = (url: string): URL => {
  const ALLOWED_REDIRECT_ORIGINS = [window.location.origin].concat(legacyURLs);
  try {
    const urlObject = new URL(url);

    if (ALLOWED_REDIRECT_ORIGINS.includes(urlObject.origin)) {
      return urlObject;
    }
  } catch {
    // We don't care about the error, we just want to make sure that the URL is valid
  }

  return new URL(window.location.origin);
};
